<template>
  <div>
    <v-card class="pa-3">
      <div class="pb-2">
        <v-layout wrap>
          <v-flex xs8>
            <div class="primary--text">{{ intentName }}</div>
          </v-flex>
          <v-flex xs4 justify-end style="display: flex">
            <v-btn flat icon @click="$emit('close')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs8>
            <v-chip label disabled color="#0085FF" class="white--text">{{
              currentDateFilter
            }}</v-chip>
          </v-flex>
          <v-flex xs4 justify-end style="display: flex">
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              <span class="px-1">{{ $t('advanced search') }}</span>
              <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
              <em v-else class="fas fa-angle-up" />
            </v-btn>
            <v-btn dark outline color="primary" @click="handleExportXlsx">
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
          </v-flex>

          <v-flex v-if="showAdvancedSearch" xs12>
            <AdvanceSearch
              :filters="filters"
              @onSearch="handleSearch"
              @onClearSearch="handleClearSearch"
            />
          </v-flex>
        </v-layout>
      </div>

      <div>
        <DataTable
          :filters="filters"
          :intent-name="intentName"
          :export-xlsx="fetchExportXlsx"
          @onExportSuccess="fetchExportXlsx = null"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'

import { mapGetters } from 'vuex'
import DataTable from './DataTable'
import AdvanceSearch from './AdvanceSearch.vue'

export default {
  components: {
    DataTable,
    AdvanceSearch
  },
  props: {
    intentName: {
      type: String,
      default: ''
    },
    dateFilter: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showFilterDate: false,
      filters: {
        customer_name: '',
        score_first_question: '',
        sent_survey_date_from: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
        sent_survey_date_to: dayjs().format('YYYY-MM-DD'),
        submit_survey_date_from: '',
        submit_survey_date_to: ''
      },
      showAdvancedSearch: false,
      dataItems: [],
      fetchExportXlsx: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    currentDateFilter() {
      const startDate = dayjs(this.filters.sent_survey_date_from).format('DD/MM/YYYY')
      const endDate = dayjs(this.filters.sent_survey_date_to).format('DD/MM/YYYY')
      return `${startDate} - ${endDate}`
    }
  },
  mounted() {
    if (this.intentName && this.dateFilter) {
      this.filters = {
        ...this.filters,
        sent_survey_date_from: this.dateFilter.start_date,
        sent_survey_date_to: this.dateFilter.end_date
      }
    }
  },
  methods: {
    handleSearch(value) {
      if (value) {
        this.filters = {
          customer_name: value.customer_name || '',
          score_first_question: value.score_first_question || '',
          sent_survey_date_from: value.sent_survey_date_from || '',
          sent_survey_date_to: value.sent_survey_date_to || '',
          submit_survey_date_from: value.submit_survey_date_from || '',
          submit_survey_date_to: value.submit_survey_date_to || ''
        }
      }
    },
    handleClearSearch() {
      this.filters = {
        customer_name: '',
        score_first_question: '',
        sent_survey_date_from: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
        sent_survey_date_to: dayjs().format('YYYY-MM-DD'),
        submit_survey_date_from: '',
        submit_survey_date_to: ''
      }
    },
    handleExportXlsx() {
      this.fetchExportXlsx = new Date()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/generali/SatisfactionSurveyReport/SatisfactionDetail/index.vue